import { render, staticRenderFns } from "./pretemplate-list.vue?vue&type=template&id=6d61284b&scoped=true&"
import script from "./pretemplate-list.vue?vue&type=script&lang=js&"
export * from "./pretemplate-list.vue?vue&type=script&lang=js&"
import style0 from "./pretemplate-list.vue?vue&type=style&index=0&id=6d61284b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61284b",
  null
  
)

export default component.exports